import httpClient from '../../httpClient';

export const getAllRoles = () => {
  return httpClient({
    method: "GET",
    url: "/super-admin/roles/all",
  });
};
